/**
 * Shared settings for the "Download" button on the application details
 * screens (the applicant's and the Admin's View Application, and the L1, L2
 * and L3 application details).
 *
 * html2pdf draws the whole screen as one tall picture and cuts it into pages
 * at fixed heights. Without page-break rules the cut lands wherever the page
 * ends, so a row near the bottom of a page (for example Mobile No.) was split
 * in half, its top on one page and its bottom on the next.
 *
 * The `avoid` list names the elements that must stay whole. When one of them
 * crosses the bottom of a page, html2pdf adds empty space before it so the
 * whole row starts on the next page instead.
 */

/** Marks one element the PDF must never cut in half (used on each field row). */
export const PDF_KEEP_TOGETHER_CLASS = "pdf-keep-together";

/**
 * Elements kept whole on one page:
 * - the class above, set on every numbered field row (ShowField);
 * - the "label : value" rows built with Tailwind in the extra summaries
 *   (Offline Tentative details, Inward / Outward);
 * - the inline-styled "label : value" rows of the review sections;
 * - table rows and images.
 * Only single rows are listed, never whole sections, so a long section still
 * flows across pages and no large blank gaps appear.
 */
const PDF_KEEP_TOGETHER_SELECTORS = [
  `.${PDF_KEEP_TOGETHER_CLASS}`,
  "div.flex.items-center",
  'div[style*="align-items: center"]',
  "tr",
  "img",
];

/** html2pdf options for the application download. */
export const APPLICATION_PDF_OPTIONS = {
  margin: 1,
  filename: "page.pdf",
  image: {
    type: "jpeg",
    quality: 0.98,
  },
  html2canvas: {
    scale: 2,
  },
  jsPDF: {
    unit: "in",
    format: "letter",
    orientation: "portrait",
  },
  pagebreak: {
    mode: ["css", "legacy"],
    avoid: PDF_KEEP_TOGETHER_SELECTORS,
  },
};
